import React, { useState, useEffect, useRef } from 'react';
import { Calendar, Checkdevice, Portalmodal, refresh } from '../../components';
import { VENDORPROFILE_COLLECTION_VENDORTYPE_EVENT, VENDORPROFILE_COLLECTION_VENDORTYPE_WEDDING, READABLE_VENDORTYPE_MAP, RECAPTCHA_KEY, FB_APPID, INVERSE_READABLE_VENDORTYPE_MAP, FACEBOOKGATE, COUNTRY_RELATED_DATA, STARTUP_NAME, SUPPORT_EMAIL, eventgate, production } from '../../config/constants';
import { USER_CHECKUSERNAME, USER_CREATE } from '../../config/api';
import ReCAPTCHA from "react-google-recaptcha";
import { FacebookLogin } from 'react-facebook-login-component';
import { emailRegex, usernameandnameRegex } from '../../config/regex';
import axios from 'axios'
import { iconwrapper } from '../../config/commonfunctions';
import {
    PHOTOGRAPHY_ICON, VIDEOGRAPHER_ICON, VENUE_ICON, TRANSPORT_ICON, PLANNER_ICON,
    MUSIC_ICON, MENSWEAR_ICON, JEWELLERY_ICON, HONEYMOON_ICON, GIFTS_ICON, EVENTRENTALS_ICON,
    ENTERTAINMENT_ICON, EMCEES_ICON, DJ_ICON, DECORATION_ICON, DANCE_ICON, CATERING_ICON,
    BRIDALBOUTIQUES_ICON, BEAUTY_ICON, BAKERYDESSERT_ICON, ACCESSORIES_ICON, PHOTOBOOTH_ICON
} from '../../config/svgicons';
import '../../../node_modules/react-datepicker/dist/react-datepicker-cssmodules.css';
import './UserSignup.css'

const PRESENCE_LOCATION = Object.keys(COUNTRY_RELATED_DATA)
const generatoriconstyle = { width: 45, height: 45, padding: 10 }
const allicons = [
    PHOTOGRAPHY_ICON, VIDEOGRAPHER_ICON, VENUE_ICON, TRANSPORT_ICON, PLANNER_ICON,
    MUSIC_ICON, MENSWEAR_ICON, JEWELLERY_ICON, HONEYMOON_ICON, GIFTS_ICON, EVENTRENTALS_ICON,
    ENTERTAINMENT_ICON, EMCEES_ICON, DJ_ICON, DECORATION_ICON, DANCE_ICON, CATERING_ICON,
    BRIDALBOUTIQUES_ICON, BEAUTY_ICON, BAKERYDESSERT_ICON, ACCESSORIES_ICON, PHOTOBOOTH_ICON
]
const min = 0;
const max = allicons.length - 1;
const iconsfunc = () => <div style={{ display: 'flex', flexDirection: 'row' }}>
    {allicons.map((icon, index) => {
        const randomInt1 = Math.floor(Math.random() * (max - min + 1)) + min;
        return <div key={index} style={{ padding: 25, color: 'rgba(235, 93, 123, 0.07)' }}>
            {iconwrapper(allicons[randomInt1], generatoriconstyle)}
        </div>
    })}
</div>

const iconbg = (
    <div className='usersignup_bg' style={{ width: '100%', height: '100%', position: 'absolute', zIndex: -1, overflow: 'hidden', transform: 'rotate(-380deg) scale(1.5)' }}>
        {iconsfunc()}
        {iconsfunc()}
        {iconsfunc()}
        {iconsfunc()}
        {iconsfunc()}
        {iconsfunc()}
        {iconsfunc()}
        {iconsfunc()}
        {iconsfunc()}
        {iconsfunc()}
        {iconsfunc()}
        {iconsfunc()}
        {iconsfunc()}
        {iconsfunc()}
        {iconsfunc()}
    </div>
)

const TERMS_COND = <div id='usersignup_termsandcond'>
    <p>This Data Protection Notice (“Notice”) sets out the basis which [name of organisation] (“we”, “us”, or “our”) may collect, use, disclose or otherwise process personal data of our customers in accordance with the Personal Data Protection Act (“PDPA”). This Notice applies to personal data in our possession or under our control, including personal data in the possession of organisations which we have engaged to collect, use, disclose or process personal data for our purposes.</p>
    <h4>PERSONAL DATA</h4>
    <ul>
        <li>“customer” means an individual who (a) has contacted us through any means to find out more about any goods or services we provide, or (b) may, or has, entered into a contract with us for the supply of any goods or services by us; and</li>
        <li> “personal data” means data, whether true or not, about a customer who can be identified: (a) from that data; or (b) from that data and other information to which we have or are likely to have access.</li>
        <li>Depending on the nature of your interaction with us, some examples of personal data which we may collect from you include your name and identification information such as your NRIC number, contact information such as your address, email address or telephone number, nationality, gender, date of birth, marital status, photographs and other audio-visual information, employment information and financial information such as credit card numbers, debit card numbers or bank account information.</li>
        <li>Other terms used in this Notice shall have the meanings given to them in the PDPA (where the context so permits).</li>
    </ul>
    <h4>COLLECTION, USE AND DISCLOSURE OF PERSONAL DATA </h4>
    <ul>
        <li>We generally do not collect your personal data unless (a) it is provided to us voluntarily by you directly or via a third party who has been duly authorised by you to disclose your personal data to us (your “authorised representative”) after (i) you (or your authorised representative) have been notified of the purposes for which the data is collected, and (ii) you (or your authorised representative) have provided written consent to the collection and usage of your personal data for those purposes, or (b) collection and use of personal data without consent is permitted or required by the PDPA or other laws. We shall seek your consent before collecting any additional personal data and before using your personal data for a purpose which has not been notified to you (except where permitted or authorised by law).</li>
        <li>We may collect and use your personal data for any or all of the following purposes:
            <ul>
                <li> performing obligations in the course of or in connection with our provision of the goods and/or services requested by you;</li>
                <li>verifying your identity;</li>
                <li>responding to, handling, and processing queries, requests, applications, complaints, and feedback from you;</li>
                <li>managing your relationship with us; </li>
                <li>processing payment or credit transactions; </li>
                <li>sending your marketing information about our goods or services including notifying you of our marketing events, initiatives and promotions, lucky draws, membership and rewards schemes and other promotions;</li>
                <li>complying with any applicable laws, regulations, codes of practice, guidelines, or rules, or to assist in law enforcement and investigations conducted by any governmental and/or regulatory authority;</li>
                <li>any other purposes for which you have provided the information; </li>
                <li>transmitting to any unaffiliated third parties including our third party service providers and agents, and relevant governmental and/or regulatory authorities, whether in Singapore or abroad, for the aforementioned purposes; and</li>
                <li>any other incidental business purposes related to or in connection with the above.</li>
            </ul>
        </li>
        <li>We may disclose your personal data:</li>
        <ul>
            <li>where such disclosure is required for performing obligations in the course of or in connection with our provision of the goods or services requested by you; or</li>
            <li>to third party service providers, agents and other organisations we have engaged to perform any of the functions listed in clause 5 above for us.</li>
        </ul>
        <li>The purposes listed in the above clauses may continue to apply even in situations where your relationship with us (for example, pursuant to a contract) has been terminated or altered in any way, for a reasonable period thereafter (including, where applicable, a period to enable us to enforce our rights under any contract with you).</li>
    </ul>
    <h4>WITHDRAWING YOUR CONSENT </h4>
    <li>The consent that you provide for the collection, use and disclosure of your personal data will remain valid until such time it is being withdrawn by you in writing. You may withdraw consent and request us to stop using and/or disclosing your personal data for any or all of the purposes listed above by submitting your request in writing or via email to our Data Protection Officer at the contact details provided below.</li>
    <li>Upon receipt of your written request to withdraw your consent, we may require reasonable time (depending on the complexity of the request and its impact on our relationship with you) for your request to be processed and for us to notify you of the consequences of us acceding to the same, including any legal consequences which may affect your rights and liabilities to us. In general, we shall seek to process your request within ten (10) business days of receiving it.</li>
    <li>Whilst we respect your decision to withdraw your consent, please note that depending on the nature and scope of your request, we may not be in a position to continue providing our goods or services to you and we shall, in such circumstances, notify you before completing the processing of your request. Should you decide to cancel your withdrawal of consent, please inform us in writing in the manner described in clause 8 above.</li>
    <li>Please note that withdrawing consent does not affect our right to continue to collect, use and disclose personal data where such collection, use and disclose without consent is permitted or required under applicable laws.</li>
    <h4>ACCESS TO AND CORRECTION OF PERSONAL DATA</h4>
    <li>If you wish to make (a) an access request for access to a copy of the personal data which we hold about you or information about the ways in which we use or disclose your personal data, or (b) a correction request to correct or update any of your personal data which we hold about you, you may submit your request in writing or via email to our Data Protection Officer at the contact details provided below.</li>
    <li>Please note that a reasonable fee may be charged for an access request. If so, we will inform you of the fee before processing your request.</li>
    <li>We will respond to your request as soon as reasonably possible. Should we not be able to respond to your request within thirty (30) days after receiving your request, we will inform you in writing within thirty (30) days of the time by which we will be able to respond to your request. If we are unable to provide you with any personal data or to make a correction requested by you, we shall generally inform you of the reasons why we are unable to do so (except where we are not required to do so under the PDPA).</li>
    <h4>PROTECTION OF PERSONAL DATA </h4>
    <li>To safeguard your personal data from unauthorised access, collection, use, disclosure, copying, modification, disposal or similar risks, we have introduced appropriate administrative, physical and technical measures such as up-to-date antivirus protection, encryption and the use of privacy filters to secure all storage and transmission of personal data by us, and disclosing personal data both internally and to our authorised third party service providers and agents only on a need-to-know basis.</li>
    <li>You should be aware, however, that no method of transmission over the Internet or method of electronic storage is completely secure. While security cannot be guaranteed, we strive to protect the security of your information and are constantly reviewing and enhancing our information security measures.</li>
    <h4>ACCURACY OF PERSONAL DATA </h4>
    <li>We generally rely on personal data provided by you (or your authorised representative). In order to ensure that your personal data is current, complete and accurate, please update us if there are changes to your personal data by informing our Data Protection Officer in writing or via email at the contact details provided below.</li>
    <h4>RETENTION OF PERSONAL DATA  </h4>
    <li>We may retain your personal data for as long as it is necessary to fulfil the purpose for which it was collected, or as required or permitted by applicable laws. </li>
    <li>We will cease to retain your personal data, or remove the means by which the data can be associated with you, as soon as it is reasonable to assume that such retention no longer serves the purpose for which the personal data was collected, and is no longer necessary for legal or business purposes.</li>
    <h4>TRANSFERS OF PERSONAL DATA OUTSIDE OF SINGAPORE</h4>
    <li>We generally do not transfer your personal data to countries outside of Singapore. However, if we do so, we will obtain your consent for the transfer to be made and we will take steps to ensure that your personal data continues to receive a standard of protection that is at least comparable to that provided under the PDPA.</li>
    <h4>DATA PROTECTION OFFICER </h4>
    <li>{`You may contact our Data Protection Officer if you have any enquiries or feedback on our personal data protection policies and procedures, or if you wish to make any request, in the following manner: Email us at ${SUPPORT_EMAIL}`}</li>
    <h4>EFFECT OF NOTICE AND CHANGES TO NOTICE </h4>
    <li>This Notice applies in conjunction with any other notices, contractual clauses and consent clauses that apply in relation to the collection, use and disclosure of your personal data by us.</li>
    <li>We may revise this Notice from time to time without any prior notice. You may determine if any such revision has taken place by referring to the date on which this Notice was last updated. Your continued use of our services constitutes your acknowledgement and acceptance of such changes.</li>
    <div style={{ height: 30 }} />
    <div>Effective date : 01/01/2024</div>
    <div>Last updated : 01/01/2024</div>
</div>

const MAX_CHECKUN = 15
const CAT_VENDOR_MAP = { 'Wedding': VENDORPROFILE_COLLECTION_VENDORTYPE_WEDDING, 'Event': VENDORPROFILE_COLLECTION_VENDORTYPE_EVENT }
const MSG_MAP = {
    'EMAILORUN_ALRDY_EXIST': 'Email or Username already in use.',
    'EMAIL_INCORRECT': 'Incorrect email.',
    'PW_INCORRECT': 'Incorrect password.',
    'FIELDS_INCOMPLETE': 'Please fill in all fields.',
    'SUCCESS_REG': 'Successfully sign up.',
    'FAIL_REG': 'Fail to sign up',
    'SUCCESS_SIGNUP_EMAIL_VERIFY': 'Successfully sign up, please verify your email. ',
    'SPECIAL_CHAR': 'Username cannot contain unique character & space',
    'UNAME_LEN': 'Username character max limit : 30, min limit: 5',
    'PASSWORD_TOOLONG': 'Password too long.'
}

const username_maxlen = 'Username must be between 6 and 30 characters. '
const username_allowchars = 'Only letters, numbers are allowed. '
const password_maxallow = 'Password must be between 6 and 50 characters. '
const name_incorrect = `Are you sure that you've entered your name correctly? `
const name_maxlen = 'Name must be between 2 and 30 characters. '
const email_maxlen = 'Username must be between 6 and 30 characters. '
const email_allowchars = 'Ensure you have enter correct email address. '
const cfmpw_correct = 'Your password and confirmation password do not match.'
const solve_captcha = 'Solve the captcha to sign up. '

const errorfunc_map = {
    'username': [
        (val) => { return (val.length > 5 && val.length < 31) ? '' : username_maxlen }, // check max len
        (val) => { return val.match(usernameandnameRegex) ? '' : username_allowchars } // check regex
    ],
    'password': [
        (val) => { return (val.length > 5 && val.length < 51) ? '' : password_maxallow }, // check max len
    ],
    'name': [
        (val) => { return (val.length > 1 && val.length < 31) ? '' : name_maxlen }, // check max len
        (val) => { return val.match(usernameandnameRegex) ? '' : name_incorrect } // check regex
    ],
    'email': [
        (val) => { return (val.length > 5 && val.length < 31) ? '' : email_maxlen }, // check max len
        (val) => { return val.match(emailRegex) ? '' : email_allowchars } // check regex

    ]
}

function UserSignup(props) {

    const [currpage, setCurrpage] = useState(0)
    const [usertype, setUsertype] = useState('Wedding') // Guest, Wedding, Event
    const [name, setName] = useState('')
    const [namemsg, setNamemsg] = useState('')
    const [spousename, setSpousename] = useState('')
    const [spousenamemsg, setSpousenamemsg] = useState('')
    const [weddt, setWeddt] = useState('')
    const [eventdt, setEventdt] = useState('')
    const [items_w, setItems_w] = useState([]) // vendortypes for wedding
    const [items_e, setItems_e] = useState([]) // vendortypes for event
    const [authstrategy, setAuthstrategy] = useState('emailpw') // emailpw , facebook, google
    const [location, setLocation] = useState('Singapore')
    const [wearedeciding, setWearedeciding] = useState(false)

    const [email, setEmail] = useState('')
    const [emailmsg, setEmailmsg] = useState('')
    const [username, setUsername] = useState('')
    const [usernamemsg, setUsernamemsg] = useState('')
    const [pw, setPw] = useState('')
    const [pwmsg, setPwmsg] = useState('')
    const [cfmpw, setCfmpw] = useState('')
    const [cfmpwmsg, setCfmpwmsg] = useState('')
    const [dbmsg, setDbmsg] = useState('')
    const [dbstatus, setDbstatus] = useState('') // SIGNUP_CLICKED ,SUCCESS_SIGNUP_EMAIL_VERIFY set to new status when user click signup and sign up successfully
    const [checkusernamestate, setCheckusernamestate] = useState('INITIAL') // INITIAL, CHECKING, UNAVAILABLE, AVAILABLE
    const [checkusernamecounter, setCheckusernamecounter] = useState(0)
    const [modalterm, setModalterm] = useState(false)

    // to detect if captchais verified or not (FOR FORGT PW)
    const captchaRef = useRef(null) // for captcha
    const [captchagate, setCaptchagate] = useState(false)
    const [captchacode, setCaptchacode] = useState('')

    const device = Checkdevice()

    useEffect(() => {
        props.hidetopbar(true)
        return () => props.hidetopbar(false)
    }, [])

    useEffect(() => {
        if (checkusernamestate === 'CHECKING' && username.length > 0) {
            setTimeout(() => {
                let options = {
                    method: 'POST',
                    url: USER_CHECKUSERNAME,
                    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', },
                    data: { un: username }
                }
                axios(options).then((r) => {
                    const { message } = r.data
                    setCheckusernamecounter(checkusernamecounter + 1)
                    if (message === 'FAILURE') {
                        setCheckusernamestate('UNAVAILABLE')
                        return
                    }
                    else if (message === 'SUCCESS') {
                        setCheckusernamestate('AVAILABLE')
                        return
                    }
                    else if (message === 'SPAMMER') {
                        refresh()
                    }
                    setCheckusernamestate('INITIAL')
                }).catch(e => {
                    setCheckusernamestate('INITIAL')
                    refresh()
                })
            }, 3000)
        }
        if (checkusernamecounter > MAX_CHECKUN) {
            refresh()
        }
    }, [checkusernamestate])


    const back = () => {
        setCurrpage(currpage - 1)
    }

    const next = () => {
        if (currpage < 5) {
            setCurrpage(currpage + 1)
        }
    }

    const changeauthstrategy = (e) => {
        setAuthstrategy(e.target.value)
    }

    const fbsignup = (res) => {
        setDbstatus('SIGNUP_CLICKED')
        const { id, email, name, accessToken } = res
        if (email === '' || email === null || email === undefined) { // check if fb return correct email address or not
            refresh()
        }
        else {
            if (usertype === 'Wedding' && (items_w.length === 0 || (name.length === 0 || spousename.length === 0))) window.location.reload()
            else if (usertype === 'Event' && (items_e.length === 0 || name.length === 0)) window.location.reload()
            else {

                if (username !== '') {
                    // props.Submit(pointer === 0 ? 'Wedding' : 'Event', items_w, items_e, name, spousename, email,username, pw, cfmpw)
                    setDbmsg('Processing...')

                    // last processing steps: change to database standard
                    var items_w_processed = []
                    if (items_w.length > 0) {
                        items_w_processed = items_w.map(i => INVERSE_READABLE_VENDORTYPE_MAP[i])
                    }
                    var items_e_processed = []
                    if (items_e.length > 0) {
                        items_e_processed = items_e.map(i => INVERSE_READABLE_VENDORTYPE_MAP[i])
                    }

                    var local_location = location === null ? 'Singapore' : location
                    var isp = isp === null ? '' : isp

                    let options = {
                        method: 'POST',
                        url: USER_CREATE,
                        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', },
                        data: {
                            provider: 'facebook', 'password1': accessToken, 'password2': accessToken,
                            fbbbb_id: id, 'email': email, 'username': username,
                            'items_w': items_w_processed, 'items_e': items_e_processed, 'name': name,
                            'spousename': spousename, usertype: usertype, 'weddt': weddt,
                            'eventdt': eventdt, location: local_location, isp: isp
                        }
                    }

                    axios(options).then((result) => {
                        const { data, status } = result
                        const { error, msg_key = '', token } = data
                        setDbstatus(msg_key)
                        if (error === false && status === 200 && msg_key === 'SUCCESS_SIGNUP_FB') {
                            setDbmsg(MSG_MAP[msg_key])
                            setDbstatus(msg_key)
                            setPw('')
                            setCfmpw('')
                            setEmail('')
                            setUsername('')
                            // redirect to home page 
                            try {
                                localStorage.setItem("token", token)
                                props.history.push('/')
                            }
                            catch (e) {
                                refresh()
                            }
                            refresh() // after setting the token, refresh

                        }
                        else {
                            refresh()
                        }
                    }).catch(e => {
                        refresh()
                    })



                }
                else {
                    if (captchagate === false) setDbmsg('Please complete the reCAPTCHA')
                    else setDbmsg('Password is wrong.')
                }


            }
        }
    }

    const emailpwsignup = () => {
        if (usertype === 'Wedding' && (items_w.length === 0 || (name.length === 0 || spousename.length === 0))) window.location.reload()
        else if (usertype === 'Event' && (items_e.length === 0 || name.length === 0)) window.location.reload()
        else {

            if (production) {
                if (email !== '' && username !== '' && pw !== '' && pw === cfmpw && captchagate) {
                    setDbmsg('Processing...')

                    // last processing steps: change to database standard
                    var items_w_processed = []
                    if (items_w.length > 0) {
                        items_w_processed = items_w.map(i => INVERSE_READABLE_VENDORTYPE_MAP[i])
                    }
                    var items_e_processed = []
                    if (items_e.length > 0) {
                        items_e_processed = items_e.map(i => INVERSE_READABLE_VENDORTYPE_MAP[i])
                    }

                    var local_location = location === null ? 'Singapore' : location
                    var isp = isp === null ? '' : isp

                    let options = {
                        method: 'POST',
                        url: USER_CREATE,
                        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', },
                        data: { 'provider': 'emailpw', 'password1': pw, 'password2': cfmpw, 'email': email, 'username': username, 'items_w': items_w_processed, 'items_e': items_e_processed, 'name': name, 'spousename': spousename, usertype: usertype, 'weddt': weddt, 'eventdt': eventdt, location: local_location, isp: isp, captchacode }
                    }

                    axios(options).then((result) => {
                        const { data, status } = result
                        const { error, msg_key = '' } = data
                        setDbstatus(msg_key)
                        if (error === false && status === 200) {
                            var ishotmail = email.substring(email.length - 11, email.length) === 'hotmail.com' ? 'If you are using hotmail, please check your spam box.' : ''

                            setDbmsg(MSG_MAP[msg_key] + ishotmail)
                            setPw('')
                            setCfmpw('')
                            setEmail('')
                            setUsername('')
                        }
                        else if (error === true) {
                            setDbstatus('')
                            setDbmsg(MSG_MAP[msg_key])
                        }
                    }).catch(e => {
                        refresh()
                    })

                }
                else {
                    if (captchagate === false) setDbmsg('Please complete the reCAPTCHA')
                    else setDbmsg('Password is wrong.')
                }

            }
            else { // none production 
                if (email !== '' && username !== '' && pw !== '' && pw === cfmpw) {
                    setDbmsg('Processing...')

                    // last processing steps: change to database standard
                    var items_w_processed = []
                    if (items_w.length > 0) {
                        items_w_processed = items_w.map(i => INVERSE_READABLE_VENDORTYPE_MAP[i])
                    }
                    var items_e_processed = []
                    if (items_e.length > 0) {
                        items_e_processed = items_e.map(i => INVERSE_READABLE_VENDORTYPE_MAP[i])
                    }

                    var local_location = location === null ? 'Singapore' : location
                    var isp = isp === null ? '' : isp

                    let options = {
                        method: 'POST',
                        url: USER_CREATE,
                        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', },
                        data: { 'provider': 'emailpw', 'password1': pw, 'password2': cfmpw, 'email': email, 'username': username, 'items_w': items_w_processed, 'items_e': items_e_processed, 'name': name, 'spousename': spousename, usertype: usertype, 'weddt': weddt, 'eventdt': eventdt, location: local_location, isp: isp, }
                    }

                    axios(options).then((result) => {
                        const { data, status } = result
                        const { error, msg_key = '' } = data
                        setDbstatus(msg_key)
                        if (error === false && status === 200) {
                            var ishotmail = email.substring(email.length - 11, email.length) === 'hotmail.com' ? 'If you are using hotmail, please check your spam box.' : ''

                            setDbmsg(MSG_MAP[msg_key] + ishotmail)
                            setPw('')
                            setCfmpw('')
                            setEmail('')
                            setUsername('')
                        }
                        else if (error === true) {
                            setDbstatus('')
                            setDbmsg(MSG_MAP[msg_key])
                        }
                    }).catch(e => {
                        refresh()
                    })

                }
                else {
                    if (captchagate === false) setDbmsg('Please complete the reCAPTCHA')
                    else setDbmsg('Password is wrong.')
                }

            }

        }
    }

    const changeUsertype = (e) => {
        setUsertype(e.target.value);
        setNamemsg('');
        setSpousenamemsg('');
    }

    const changeDatecheckbox = () => {
        if (!wearedeciding) {
            setWeddt('');
            setEventdt('');
        }
        setWearedeciding(!wearedeciding);
    }

    const btmnav_dom = <div id='usersignup_btm' key={usertype + '_btmnav'}>
        {currpage === 0 || 'SUCCESS_SIGNUP_EMAIL_VERIFY' === dbstatus || 'SIGNUP_ONCLICKED' === dbstatus
            ? null
            : <button id='usersignup_back' onClick={back} disabled={'SUCCESS_SIGNUP_EMAIL_VERIFY' === dbstatus}>Back</button>}

        {currpage === 0 && (usertype === 'Wedding' || usertype === 'Event')
            ? <button
                id='usersignup_next'
                onClick={() => {
                    setSpousenamemsg('')
                    setNamemsg('')
                    if (usertype === 'Wedding') {
                        const namecheck1 = errorfunc_map['name'][0](name)
                        const namecheck2 = errorfunc_map['name'][1](name)
                        if (namecheck1.length > 0 || namecheck2.length > 0) {
                            setNamemsg(namecheck1 + namecheck2)
                        }

                        const spousenamecheck1 = errorfunc_map['name'][0](spousename)
                        const spousenamecheck2 = errorfunc_map['name'][1](spousename)
                        if (spousenamecheck1.length > 0 || spousenamecheck2.length > 0) {
                            setSpousenamemsg(spousenamecheck1 + spousenamecheck2)
                        }

                        if (
                            spousenamecheck1.length === 0 &&
                            spousenamecheck2.length === 0 &&
                            namecheck1.length === 0 &&
                            namecheck2.length === 0 &&
                            currpage < 5) {
                            setCurrpage(currpage + 1)
                            setSpousenamemsg('')
                            setNamemsg('')
                        }
                    }
                    else if (usertype === 'Event') {
                        const namecheck1 = errorfunc_map['name'][0](name)
                        const namecheck2 = errorfunc_map['name'][1](name)
                        if (namecheck1.length > 0 || namecheck2.length > 0) {
                            setNamemsg(namecheck1 + namecheck2)
                        }

                        if (
                            namecheck1.length === 0 &&
                            namecheck2.length === 0 &&
                            currpage < 5) {
                            setCurrpage(currpage + 1)
                            setNamemsg('')
                        }
                    }
                }}
            >Next</button>
            : null}

        {currpage === 1 && ((usertype === 'Wedding' && weddt !== '') || (usertype === 'Event' && eventdt !== '') || wearedeciding)
            ? <button id='usersignup_next' onClick={next}>Next</button>
            : null}

        {currpage === 2 && usertype === 'Wedding' && items_w.length > 0
            ? <button id='usersignup_next' onClick={next}>Next</button>
            : null}

        {currpage === 2 && usertype === 'Event' && items_e.length > 0
            ? <button id='usersignup_next' onClick={next}>Next</button>
            : null}

        {currpage === 3 && location.length > 0
            ? <button id='usersignup_next' onClick={next}>Next</button>
            : null}

        {/* {currpage === 3 && (usertype === 'Wedding' || usertype === 'Event') && username && username.length > 0 && (pw === cfmpw && pw.length > 0) && authstrategy === 'emailpw' && captchacode && captchacode.length > 0 */}
        {currpage === 4 && 'SUCCESS_SIGNUP_EMAIL_VERIFY' !== dbstatus && authstrategy === 'emailpw'
            ? <button id='usersignup_next'
                onClick={() => {

                    setDbstatus('SIGNUP_CLICKED')
                    if (dbstatus !== 'SUCCESS_SIGNUP_EMAIL_VERIFY') {
                        const usernamecheck1 = errorfunc_map['username'][0](username)
                        const usernamecheck2 = errorfunc_map['username'][1](username)
                        const emailcheck1 = errorfunc_map['email'][0](email)
                        const emailcheck2 = errorfunc_map['email'][1](email)
                        const pwcheck1 = errorfunc_map['password'][0](pw)
                        const cfmpwcheck1 = errorfunc_map['password'][0](cfmpw)
                        const pwconfirmation = cfmpw !== pw ? cfmpw_correct : ''
                        setUsernamemsg(usernamecheck1 + usernamecheck2)
                        setEmailmsg(emailcheck1 + emailcheck2)
                        setPwmsg(pwcheck1 + pwconfirmation)
                        setCfmpwmsg(cfmpwcheck1 + pwconfirmation)
                        setDbmsg(captchacode.length < 0 ? solve_captcha : '')
                        if ((usernamecheck1 + usernamecheck2 + emailcheck1 + emailcheck2 + pwcheck1 + pwconfirmation) === '') {
                            emailpwsignup()
                        }
                        else {
                            setDbstatus('')
                        }
                    }
                }}>Sign Up</button>
            : null}

    </div>


    // select usertype and enter names page
    const namepage = <div id='usersignuppage_root'>
        <div id='usersignuppage_page1'>
            {eventgate
                ? <div id='usersignuppage_pagetop'>
                    <div className='usersignup_commontxt'>Preparing for</div>
                    <button className={`usersignuppage_mainbtn ${usertype === 'Wedding' ? 'usersignuppage_mainbtntxtselected' : ''}`} value="Wedding" onClick={changeUsertype} >Wedding</button>
                    <div className='usersignup_commontxt'>or</div>
                    <button className={`usersignuppage_mainbtn  ${usertype === 'Event' ? 'usersignuppage_mainbtntxtselected' : ''}`} value="Event" onClick={changeUsertype}>Event</button>
                </div>
                : null}
            <div id='usersignuppage_page1inputsroot'>
                {/* name input */}
                <div id='usersignuppage_inputroot'>
                    <input
                        value={name}
                        className='usersignuppage_generalinput'
                        placeholder="Your Name"
                        autoComplete={'off'}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <div id='usersignuppage_inputmsg'>{namemsg}</div>
                </div>
                {/* spousename input */}
                <div id='usersignuppage_inputroot'>
                    <input
                        value={spousename}
                        disabled={usertype === 'Wedding' ? false : true}
                        className={`usersignuppage_generalinput ${usertype === 'Wedding' ? '' : 'usersignuppage_generalinputdisabled'}`}
                        placeholder="Your Spouse's Name"
                        autoComplete={'off'}
                        onChange={(e) => setSpousename(e.target.value)}
                    />
                    <div id='usersignuppage_inputmsg'>{spousenamemsg}</div>
                </div>
            </div>
        </div>
    </div>

    // select date page
    const datepage = <div id='usersignuppage_root'>
        <div id='usersignuppage_pagetop'>

            <div className='usersignup_commontxt usersignup_page2commontxt'>
                {usertype === 'Wedding'
                    ? 'Your Wedding Date'
                    : 'Your Event Date'}
            </div>

            <div className='usersignup_calendarroot'>
                <Calendar
                    check={usertype === 'Wedding' ? weddt.toString().length > 0 : eventdt.toString().length > 0}
                    selected={usertype === 'Wedding' ? weddt : eventdt}
                    onChange={(e) => {
                        usertype === 'Wedding' ? setWeddt(e) : setEventdt(e);
                        setWearedeciding(false);
                    }}
                    updateDate={() => { setWeddt(''); setEventdt(''); }}
                />
            </div>

            <div className='usersignuppage_idonthavedate' onClick={changeDatecheckbox}>
                <input className='usersignup_donthavedatecheckbox' type="checkbox" checked={wearedeciding} onChange={changeDatecheckbox} />
                <div className='usersignup_donthavedatecheckboxlbl'>
                    {usertype === 'Wedding'
                        ? `We're still deciding`
                        : 'No specific date'}
                </div>
            </div>

        </div>
    </div>

    // select vendortypes
    const vtpage = <div id='usersignuppage_root'>
        <div id='usersignuppage_pagetop'>
            <div className='usersignup_commontxt'>Select Vendors</div>
            <div className='usersignup_commonsubtxt'>Customise your homepage to your preference</div>
            <div id='usersignuppage_vtroot' >
                {(usertype === 'Wedding' || usertype === 'Event') && CAT_VENDOR_MAP[usertype].map((item, i) => {

                    item = READABLE_VENDORTYPE_MAP[item]

                    var items_arr
                    if (usertype === 'Wedding') items_arr = items_w.slice()
                    else items_arr = items_e.slice()

                    return (
                        <button
                            key={item + i}
                            className={items_arr.includes(item) ? "SELECTED_MSB_vtbtn" : "MSB_vtbtn"}
                            onClick={() => {
                                var items_arr
                                if (usertype === 'Wedding') { // wedding
                                    items_arr = items_w.slice()
                                    for (let i = 0; i < items_arr.length; i++) {
                                        if (items_arr[i] === item) {
                                            items_arr.splice(items_arr.indexOf(item), 1)
                                            setItems_w(items_arr)
                                            return
                                        }
                                    }
                                    items_arr.push(item)
                                    setItems_w(items_arr)
                                }
                                else { // event
                                    items_arr = items_e.slice()
                                    for (let i = 0; i < items_arr.length; i++) {
                                        if (items_arr[i] === item) {
                                            items_arr.splice(items_arr.indexOf(item), 1)
                                            setItems_e(items_arr)
                                            return
                                        }
                                    }
                                    items_arr.push(item)
                                    setItems_e(items_arr)
                                }
                            }}>
                            {item}
                        </button>
                    )
                })}
            </div>
        </div>
    </div>

    // const page4_old = <div id='usersignuppage_root'>
    //     <div id='usersignuppage_pagetop'>
    //         <div className='usersignup_commontxt usersignup_page2commontxt'>
    //             Your Location
    //         </div>
    //         <div className='usersignup_locationroot'>
    //             {PRESENCE_LOCATION.map((loc, index) => {
    //                 return <button
    //                     value={loc}
    //                     className={`usersignup_locbtn ${location === loc ? 'SELECTED_MSB_vtbtn' : 'MSB_vtbtn'}`}
    //                     onClick={() => {
    //                         setLocation(loc)
    //                     }}
    //                     key={loc + index}
    //                 >
    //                     {loc}
    //                 </button>
    //             })}
    //         </div>
    //     </div>
    // </div>

    const locationpage = (
        <div id='usersignuppage_root'>
            <div id='usersignuppage_pagetop'>
                <div className='usersignup_commontxt usersignup_page2commontxt'>
                    Your Location
                </div>
    
                <div className='usersignup_locationroot'>
                    <select
                        className='usersignup_locationselect'
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                    >
                        <option value="">Select a location</option>
    
                        {PRESENCE_LOCATION.map((loc, index) => (
                            <option
                                key={`${loc}-${index}`}
                                value={loc}
                            >
                                {loc}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );

    const termsdom = <div id="usersignuppage_termsroot">
        <div className='usersignuppage_smalltext' onClick={() => { setModalterm(!modalterm) }} >
            <div>{`By signing up, you agree to ${STARTUP_NAME}'s Terms of service.`}</div>
            <div id="usersignuppage_termshere">Here.</div>
        </div>
    </div>

    const captchadom = <div id='usersignuppage_recaptcha'>
        {authstrategy === 'emailpw' && email.length > 0 && pw.length > 0 && pw === cfmpw && username.length > 0
            ? <div className='usersignuppage_recaptchacol'>
                <div className='usersignuppage_smalltextcaptcha'>Complete the reCAPTCHA to signup.</div>
                <ReCAPTCHA
                    ref={(el) => { captchaRef.current = el }}
                    sitekey={RECAPTCHA_KEY}
                    onChange={(res) => {
                        setCaptchacode((res && res.length > 0) ? res : '')
                        setCaptchagate(res ? true : false)
                    }}
                />
            </div>
            : null}
        {termsdom}
    </div>

    const signuppage = <div id='usersignuppage_root'>
        {dbstatus !== 'SUCCESS_SIGNUP_EMAIL_VERIFY'
            ? <div id='usersignuppage_pagetop'>
                <div id='usersignuppage_authbtnroot'>
                    <button className={`usersignuppage_authbtn ${authstrategy === 'emailpw' ? 'usersignuppage_authbtnselected' : ''}`} value='emailpw' onClick={changeauthstrategy}>Email/Passwords</button>
                    {FACEBOOKGATE ? <button className={`usersignuppage_authbtn ${authstrategy === 'facebook' ? 'usersignuppage_authbtnselected' : ''}`} value='facebook' onClick={changeauthstrategy}>Facebook</button> : null}
                </div>
            </div>
            : null}
        {authstrategy === 'emailpw'
            ? <div id='usersignuppage_authcol'>
                <div id='usersignuppage_inputroot'>
                    <input
                        value={username}
                        disabled={dbstatus === 'SUCCESS_SIGNUP_EMAIL_VERIFY' || dbstatus === 'SIGNUP_CLICKED'}
                        className='usersignuppage_generalinput'
                        placeholder="Username"
                        onChange={(e) => {
                            var val = e.target.value.toLowerCase()
                            if (val.match(usernameandnameRegex) || val === '') {
                                setUsername(val)
                            }
                        }}
                        autoComplete={'off'}
                    />
                    <div id='usersignuppage_inputmsg'>{usernamemsg}</div>
                </div>

                <div id='usersignuppage_inputroot'>
                    <input
                        value={email}
                        disabled={dbstatus === 'SUCCESS_SIGNUP_EMAIL_VERIFY' || dbstatus === 'SIGNUP_CLICKED'}
                        className='usersignuppage_generalinput'
                        placeholder="Email"
                        type="email"
                        pattern={"[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"}
                        onChange={(e) => setEmail(e.target.value)}
                        autoComplete={'off'}
                    />
                    <div id='usersignuppage_inputmsg'>{emailmsg}</div>
                </div>

                <div id='usersignuppage_inputroot'>
                    <input
                        value={pw}
                        disabled={dbstatus === 'SUCCESS_SIGNUP_EMAIL_VERIFY' || dbstatus === 'SIGNUP_CLICKED'}
                        className='usersignuppage_generalinput'
                        placeholder="Password"
                        onChange={(e) => { setPw(e.target.value) }}
                        autoComplete={'off'}
                        type='password'
                    />
                    <div id='usersignuppage_inputmsg'>{pwmsg}</div>
                </div>


                <div id='usersignuppage_inputroot'>
                    <input
                        value={cfmpw}
                        disabled={dbstatus === 'SUCCESS_SIGNUP_EMAIL_VERIFY' || dbstatus === 'SIGNUP_CLICKED'}
                        className='usersignuppage_generalinput'
                        placeholder="Confirm Password"
                        onChange={(e) => { setCfmpw(e.target.value) }}
                        autoComplete={'off'}
                        type='password'
                    />
                    <div id='usersignuppage_inputmsg'>{cfmpwmsg}</div>
                </div>

                <div id="usersignuppage_msg">
                    {dbmsg}
                </div>
                {dbstatus === 'SUCCESS_SIGNUP_EMAIL_VERIFY' ? <div id='usersignup_clicktologin' onClick={() => { props.history.push('/') }}>Click Here to login after you have verify your email.</div> : null}

                {production ? captchadom : null}

            </div>
            : <div id='usersignuppage_authcol'>
                <div id='usersignuppage_inputroot'>
                    <input
                        value={username}
                        disabled={dbstatus === 'SUCCESS_SIGNUP_EMAIL_VERIFY' || dbstatus === 'SIGNUP_CLICKED'}
                        className='usersignuppage_generalinput'
                        placeholder="Username"
                        onChange={(e) => {
                            var val = e.target.value.toLowerCase()
                            if (val.match(usernameandnameRegex) || val === '') {
                                setUsername(val)
                            }
                            setCheckusernamestate('INITIAL')
                        }}
                        autoComplete={'off'}
                    />
                    <div id='usersignuppage_inputmsg'></div>
                </div>

                {username.length > 0
                    ? {
                        'INITIAL': <button id='usersignuppage_checkavabtn' onClick={() => setCheckusernamestate('CHECKING')}>Check Availability</button>,
                        'CHECKING': <button id='usersignuppage_checkavabtn'>Checking...</button>,
                        'AVAILABLE': <button id='usersignuppage_checkavabtn' >Username Is Available.</button>,
                        'UNAVAILABLE': <button id='usersignuppage_checkavabtn' >Username Is Not Available.</button>
                    }[checkusernamestate]
                    : null}

                {authstrategy === 'facebook' && checkusernamestate === 'AVAILABLE'
                    ? <FacebookLogin
                        socialId={FB_APPID}
                        language="en_US"
                        scope="public_profile,email"
                        responseHandler={fbsignup}
                        xfbml={true}
                        fields="id,email,name"
                        version="v2.5"
                        className="facebook-login usersignuppage_fbfacade"
                        buttonText="Signup with Facebook"
                    />
                    : null}

                {termsdom}
            </div>
        }

    </div>

    const portalmidcss = { width: { 'WEB': 500, 'TABLET': 450, 'MOBILE': '100%' }[device], height: { 'WEB': 500, 'TABLET': 400, 'MOBILE': '100%' }[device], backgroundColor: 'white', top: '50%', left: '50%', right: '', transform: 'translate(-50%,-50%)' }

    return <div id='usersignup_root'>
        {[
            namepage,
            datepage,
            vtpage,
            locationpage,
            signuppage
        ][currpage]}
        {iconbg}
        {btmnav_dom}
        <Portalmodal
            portaltype={'commonportal'}
            open={modalterm}
            onClose={() => setModalterm(false)}
            floatingclose={false}
            backdropvisible={true}
            modalstyle={portalmidcss}
            closestyle={{ right: 0 }}
            floatingclosecolor='#333333'
        >
            <div className={device === 'MOBILE' ? 'usersignupmodalM' : 'usersignupmodal'} >
                {TERMS_COND}
            </div>
        </Portalmodal>
    </div>
}

export default UserSignup